import Verses from "../../../../api/biblia/verses";
import Loader from "../../../../components/loader";
import Swiper from "../../../../components/swiper";

export default class AdvancedSearch {
	constructor(biblia) {
		this.biblia = biblia;
		this.showSearchSection();
		this.handleSearchForm();
		this.handleNextPage();
		this.handlePreviusPage();

		this.selectTestament();
		this.selectBook();
		this.selectChapterStart();
		this.clearSearchButton();
	}

	showSearchSection() {
		const button = document.querySelector('#biblia-online #toggle-advanced-search');

		button?.addEventListener('change', () => {
			const toggle = document.querySelector('#biblia-online #toggle-button');
			const form = document.querySelector('#biblia-online #search-form');

			toggle.classList.toggle('selected');

			if (form.classList.contains('open')) {
				form.classList.remove('open');
				setTimeout(() => {
					form.classList.add('deactive');
				}, 200);

			} else {
				form.classList.remove('deactive');
				setTimeout(() => {
					form.classList.add('open');
				}, 10);
			}
		});
	}

	selectTestament() {
		const testament = document.querySelector('#biblia-online #advanced-search-testament');

		testament.addEventListener('change', () => {
			this.setBooksSelect();
		});
	}

	selectBook() {
		const books = document.querySelector('#biblia-online #advanced-search-books');

		books.addEventListener('change', () => {
			if (books.value === 'default') {
				this.resetChapterStartSelect();
				this.resetChapterEndSelect();
			} else {
				this.setChapterStartSelect();
			}
		});
	}

	selectChapterStart() {
		const chapterStart = document.querySelector('#biblia-online #advanced-search-chapter-start');

		chapterStart.addEventListener('change', () => {
			this.setChapterEndSelect();
		})
	}

	setChapterStartSelect() {
		const chapterStartSelect = document.querySelector('#biblia-online #advanced-search-chapter-start');
		const booksSelect = document.querySelector('#biblia-online #advanced-search-books');

		const selectedBook = booksSelect.options[booksSelect.selectedIndex];
		const length = parseInt(selectedBook.getAttribute('data-length'));

		chapterStartSelect.innerHTML = '';

		for (let index = 1; index <= length; index++) {
			const option = document.createElement('option');
			option.setAttribute('value', index);
			option.innerText = `Capítulo ${index}`;

			chapterStartSelect.setAttribute('data-length', length);
			chapterStartSelect.appendChild(option);
		}

		this.setChapterEndSelect();
	}

	setChapterEndSelect() {
		const chapterStartSelect = document.querySelector('#biblia-online #advanced-search-chapter-start');
		const chapterEndSelect = document.querySelector('#biblia-online #advanced-search-chapter-end');
		const start = parseInt(chapterStartSelect.value);
		const length = parseInt(chapterStartSelect.getAttribute('data-length'));

		chapterEndSelect.innerHTML = '';

		for (let index = start; index <= length; index++) {
			const option = document.createElement('option');
			option.setAttribute('value', index);
			option.innerText = `Capítulo ${index}`;

			chapterEndSelect.appendChild(option);
		}

		chapterEndSelect.value = length;
	}

	setBooksSelect() {
		const booksData = document.querySelector('#biblia-online #parresia-biblia-books');
		const booksSelect = document.querySelector('#biblia-online #advanced-search-books');
		const testamentSelect = document.querySelector('#biblia-online #advanced-search-testament');

		if(booksData.value) {
			const books = JSON.parse(booksData.value);

			this.resetBooksSelect();

			books.forEach(book => {
				if (testamentSelect.value === 'default' || testamentSelect.value === book.meta.testament) {
					const option = document.createElement('option');
					option.setAttribute('value', book.slug);
					option.setAttribute('data-length', book.chapter_count);
					option.innerText = book.chapter;

					booksSelect.appendChild(option);
				}
			});
		}
	}

	resetBooksSelect() {
		const booksSelect = document.querySelector('#biblia-online #advanced-search-books');
		booksSelect.innerHTML = '';

		const option = document.createElement('option');
		option.setAttribute('value', 'default');
		option.innerText = 'Todos os Livros';

		booksSelect.appendChild(option);

		this.resetChapterStartSelect();
		this.resetChapterEndSelect();
	}


	resetChapterStartSelect() {
		const chapterStart = document.querySelector('#biblia-online #advanced-search-chapter-start');
		chapterStart.innerHTML = '';

		const option = document.createElement('option');
		option.setAttribute('value', 'default');
		option.innerText = 'De';

		chapterStart.appendChild(option);
	}

	resetChapterEndSelect() {
		const chapterEnd = document.querySelector('#biblia-online #advanced-search-chapter-end');
		chapterEnd.innerHTML = '';

		const option = document.createElement('option');
		option.setAttribute('value', 'default');
		option.innerText = 'Até';

		chapterEnd.appendChild(option);
	}

	changeMobileView() {
		const content = document.querySelector('#biblia-online > .base > .sidebar');
		const sidebar = document.querySelector('#biblia-online > .base > .content');

		content.classList.add('mobile-deactive');
		sidebar.classList.remove('mobile-deactive');
	}

	handleSearchForm() {
		const form = document.querySelector('#search-form');

		if (form) {
			form.addEventListener('submit', (e) => {
				e.preventDefault();

				const testament = document.querySelector('#advanced-search-testament');
				const testamentText = testament.options[testament.selectedIndex];
				const book = document.querySelector('#advanced-search-books');
				const bookText = book.options[book.selectedIndex];
				const start = document.querySelector('#advanced-search-chapter-start');
				const end = document.querySelector('#advanced-search-chapter-end');
				const content = document.querySelector('#advanced-search-input');

				this.searchRequest({
					term: content.value === 'default' ? false : content.value,
					testament: testament.value === 'default' ? false : testament.value,
					testamentText: testamentText.innerText,
					book: book.value === 'default' ? false : book.value,
					bookText: bookText.innerText,
					start: start.value === 'default' ? false : start.value,
					end: end.value === 'default' ? false : end.value,
					currentPage: 1,
					previusPage: 1,
					nextPage: 2
				});

				this.changeMobileView();
			});
		}
	}

	searchRequest(search) {
		const container = document.querySelector('#biblia-online #content-display');

		const api = new Verses();
		const loader = new Loader(container);

		loader.setLoader();

		api.getVerses(
			search.book,
			search.start,
			search.end,
			search.testament,
			search.term,
			search.currentPage
		).then((data) => {
			loader.unsetLoader();

			if (data) {
				const body = data.body;

				search.totalPages = data.headers['x-wp-totalpages'];
				search.total = data.headers['x-wp-total'];
				this.setSearchView(search, body);
				this.setSearchData(search);
				this.handleSwipePage();

			} else {
				this.setSearchView(search);
			}
		});
	}

	setSearchView(search, result = false) {
		const content = document.querySelector('#biblia-online #content-display');
		content.className = 'search-content';

		const searchResult = document.createElement('div');
		searchResult.classList.add('search-result');

		content.appendChild(searchResult);

		this.setSearchTitle('Resultados');
		this.setSearchDescription(search, searchResult);
		this.setSearchControllers(search.currentPage);
		this.setResult(result, search, searchResult);
	}

	setSearchData(data) {
		const dataInput = document.querySelector("#search-data");
		dataInput.value = JSON.stringify(data);
	}

	setSearchTitle(title) {
		const element = document.querySelector('#biblia-online #content-title');
		element.innerText = title;
	}

	setSearchDescription(search, content) {

		const TestamentText = search.testamentText ? ` no ${search.testamentText},` : '';
		const bookText = search.bookText ? ` em ${search.bookText} ` : '';
		const rangeText = search.start && search.end ? `${search.start}-${search.end}` : '';

		const div = document.createElement('div');
		div.classList.add('search-description');

		const span = document.createElement('span');
		span.innerText = `Buscando o termo "${search.term}"${TestamentText}${bookText}${rangeText}.`
		div.appendChild(span);

		this.showSearchResultSection(search);

		content.innerHTML = '';
		content.appendChild(div);
	}

	showSearchResultSection(search) {
		const resultSection = document.querySelector("#search-result");
		const result = document.querySelector("#search-result > div > .search-result-quantity");

		resultSection.classList.remove('deactive');

		let total = search.total ?? 0

		if (total >= 0) {
			result.innerText = `${total} Resultados foram encontrados`;
		} else {
			result.innerText = `${total} Resultado foi encontrado`;
		}
	}

	clearSearchButton() {
		const reset = document.querySelector('#search-reset');

		reset.addEventListener('click', () => {
			this.resetSearch();
		});
	}

	resetSearch() {
		const current = document.querySelector("#biblia-online #selected-book");

		if (current.value) {
			const data = JSON.parse(current.value);
			this.biblia.chapter.setChapter(data, data.index);
		}
	}

	deativeSearchResult() {
		const resultSection = document.querySelector("#search-result");
		resultSection.classList.add('deactive');
	}

	setSearchControllers(currentPage) {
		const container = document.querySelector('#biblia-online #position-controllers > .position-controllers');
		container.classList.add('search-page-controllers');
		container.classList.remove('chapter-page-controllers');

		const currentTitle = document.querySelector('#biblia-online #position-controllers > .search-page-controllers > .current-position > div > .position-description');
		currentTitle.innerText = 'PÁGINA';

		const current = document.querySelector('#biblia-online #position-controllers #position-number');
		current.setAttribute('data-context', 'search');
		current.innerText = currentPage;

		const previusPage = document.querySelector('#biblia-online #previus-position');
		previusPage.setAttribute('data-position', parseInt(currentPage) - 1);

		const nextPage = document.querySelector('#biblia-online #next-position');
		nextPage.setAttribute('data-position', parseInt(currentPage) + 1);
	}

	setResult(verses, search, content) {

		if (!verses) {
			const text = document.createElement('span');
			text.innerText = 'Nenhum resultado encontrado';
			content.appendChild(text);

			return;
		}

		verses.forEach(verse => {
			const book = this.getBookData(verse.chapter_slug.replace(/-\d+/, ''));
			const div = document.createElement('div');
			div.classList.add('search-verse');

			const container = document.createElement('div');
			container.classList.add('search-container');
			div.appendChild(container);

			const text = document.createElement('span');
			text.innerHTML = this.contrastSearchTerm(verse.text, search.term);
			text.classList.add('font-size-15', 'search-text');
			text.setAttribute('data-size', '15');
			container.appendChild(text);

			const info = document.createElement('span');
			info.innerText = `${book.chapter} ${verse.chapter}, ${verse.number}`;
			info.classList.add('font-size-15','search-info');
			info.setAttribute('data-size', '15');
			container.appendChild(info);

			const chapter = document.createElement('span');
			chapter.innerText = 'Ir para o capítulo';
			chapter.classList.add('font-size-15','search-book-link');
			chapter.setAttribute('data-size', '15');

			chapter.addEventListener('click', () => {
				this.biblia.chapter.setChapter(book, verse.chapter);
			});

			container.appendChild(chapter);

			content.appendChild(div);
		});
	}

	getBookData(slug) {
		const contentBook = document.querySelector('#biblia-online #parresia-biblia-books');
		const data = JSON.parse(contentBook.value);

		let book;
		data.forEach(item => {
			if (item.slug && slug.includes(item.slug)) {
				book = item;
			}
		});

		return book
	}

	contrastSearchTerm(verse, term) {
		const regex = new RegExp(term, 'gi');
		return verse.replace(regex, (match) => `<i>${match}</i>`);
	}

	isSearchController() {
		const current = document.querySelector('#biblia-online #position-number');

		return current.getAttribute('data-context') === 'search';
	}


	handleNextPage() {
		const nextButton = document.querySelector('#biblia-online #next-position');

		nextButton.addEventListener('click', () => {
			this.getNextPage();
		});
	}

	getNextPage() {
		const nextButton = document.querySelector('#biblia-online #next-position');

		if (this.isSearchController()) {
			const next = parseInt(nextButton.getAttribute('data-position'));

			const search = document.querySelector('#biblia-online #search-data');
			const data = JSON.parse(search.value);

			if (data.totalPages > next) {
				data.previusPage = data.previusPage + 1;
				data.currentPage = data.currentPage + 1;
				data.nextPage = data.nextPage + 1;

				this.searchRequest(data);
			}
		}
	}

	handlePreviusPage() {
		const previusButton = document.querySelector('#biblia-online #previus-position');

		previusButton.addEventListener('click', () => {
			this.getPreviusPage();
		});
	}

	getPreviusPage() {
		const previusButton = document.querySelector('#biblia-online #previus-position');

		if (this.isSearchController()) {
			let previus = previusButton.getAttribute('data-position');
			const search = document.querySelector('#biblia-online #search-data');
			const data = JSON.parse(search.value);

			if (previus > 0) {
				data.previusPage = data.previusPage - 1;
				data.currentPage = data.currentPage - 1;
				data.nextPage = data.nextPage - 1;

				this.searchRequest(data);
			}
		}
	}

	handleSwipePage() {
		const content = document.querySelector('#biblia-online #content-display > .search-result');
		new Swiper(
			content,
			this.getPreviusPage.bind(this),
			this.getNextPage.bind(this)
		);
	}
}
